import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BaseSiteService, GlobalMessageService, GlobalMessageType } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { skip, take } from 'rxjs/operators';
import { CustomProfileAndPreferencesService } from 'src/app/custom-profile-and-preferences/custom-profile-and-preferences.service';
import { MultiFactorAuthService } from 'src/app/shared/services/multi-factor-auth.service';
import { SharedService } from 'src/app/shared/services/shared.service';
import { UserAccessManagementService } from '../user-access-management.service';

@Component({
    selector: 'app-customer-overview',
    templateUrl: './customer-overview.component.html',
    styleUrls: ['./customer-overview.component.scss'],
    standalone: false
})
export class CustomerOverviewComponent implements OnInit, OnDestroy {
  nameEditIsNotClicked = true;
  roleEditIsNotClicked = true;
  passwordEditIsNotClicked = true;
  passRecEditIsNotClicked = true;
  emailEditIsNotClicked = true;
  commConfmEditIsNotClicked = true;
  mobileEditIsNotClicked = true;
  nameForm: FormGroup;
  passwordForm: FormGroup;
  emailForm: FormGroup;
  alternateEmailForm: FormGroup;
  mobileForm: FormGroup;
  mobileNumber: string = '';
  mobileNumberMasked: string = '';
  mobileErrorMsg: string = null;
  mobileAddDisable = false;
  chosenRoleofUser = '';
  passwordYetToMatch: boolean;
  passwordIsNotValid = true;
  passwordConfirmStatus = '';
  chosenQueForPassRecovery = '';
  ansForQuePassRecovery = null;
  loginUserInfo: any;
  emailCommunicationStatus = '';
  userIdDisable: any = 'true';
  userIdDisableReadOnly: any;
  roleOfUserArray = [];
  passRecQuesArray = [];
  displayRoleofUser: any;
  displayQueForPassRecovery: any;
  showAlternateEmailField = false;
  currentPasswordIsNotValid = true;
  cPassError: any = '';
  emailRegex = '';
  userDtaaSubscriber: any;
  userRolesSubscriber: any;
  userDtaUpdateSubscriber: any;
  passQueSubscriber: any;
  userDataUpdateSubscriber2: any;
  changeLogArray: any = [];
  userIdEditIsNotClicked = true;
  customerId: any;
  updateDetailsSubscriber: any;
  cstDetailsSubscriber: any;
  resetPasswordBoolean: any = null;
  changeHistorySubscriber: any;
  changeHistoryArray: any = [];
  baseSiteId: string;
  emailRegx = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,15}$/;
  emailChangeRequested;
  constructor(
    private readonly pfService: CustomProfileAndPreferencesService,
    private readonly user: UserAccountFacade,
    private readonly ref: ChangeDetectorRef,
    private readonly userManagementService: UserAccessManagementService,
    private readonly sharedService: SharedService,
    private readonly globalMessage: GlobalMessageService,
    private readonly router: Router,
    private baseSiteService: BaseSiteService,
    private mfaService: MultiFactorAuthService
  ) {}

  ngOnInit(): void {
    this.baseSiteService
      .getActive()
      .pipe(take(1))
      .subscribe((res) => (this.baseSiteId = res));
    this.customerId = this.sharedService.getSessionStorage('customerId');
    this.formInitialisation();
    this.cstDetailsSubscriber =
      this.userManagementService.customerDetails.subscribe((userData: any) => {
        if (userData?.res) {
          this.loginUserInfo = userData?.res;
          this.getChangeHistory();
          this.userIdDisableReadOnly =
            (this.loginUserInfo?.userDisabled).toString();
          this.userIdDisable = (this.loginUserInfo?.userDisabled).toString();
          this.mobileNumber = this.loginUserInfo?.mobileNumber || '';
          if (this.mobileNumber) {
            const countryCode = this.loginUserInfo?.mobileCountryCode || 'US';
            this.mobileNumberMasked = `(${countryCode}) ` + this.mobileNumber.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '***-***-$3');
          }
          if (userData?.id === null) {
            this.setAllFormField();
            this.userRoleGetMethod();
            this.getPassWordRecQues();
          } else {
            if (userData.id === 'name') {
              this.setNameField();
            } else if (userData.id === 'role') {
              this.userRoleGetMethod();
            } else if (userData.id === 'email') {
              this.setEmailForm();
            } else if (userData.id === 'mobile') {
              this.setMobileForm();
            } else {
              // No Change
            }
          }
          this.ref.detectChanges();
        }
      });
  }

  ngOnDestroy() {
    this.changeHistorySubscriber?.unsubscribe();
    this.updateDetailsSubscriber?.unsubscribe();
    this.passQueSubscriber?.unsubscribe();
    this.userRolesSubscriber?.unsubscribe();
    this.cstDetailsSubscriber?.unsubscribe();
  }
  setAllFormField() {
    this.setNameField();
    this.setPassRecField();
    this.setEmailForm();
    this.setMobileForm();
  }
  // ===================================ChangeHistory===============================
  getChangeHistory() {
    this.userManagementService.getChangeHistory(this.customerId);
    this.changeHistorySubscriber =
      this.userManagementService.changeHistory.subscribe((data: any) => {
        if (data) {
          this.changeHistoryArray = [];
          this.changeHistoryArray = data?.modifiedEntries;
          this.ref.detectChanges();
        }
      });
  }
  // =======================All forms Initilaisation=============================
  formInitialisation() {
    this.nameForm = new FormGroup({
      actualFirstName: new FormControl('', [
        Validators.required,
        Validators.pattern("[a-zA-Z0-9 '-]*$"),
      ]),
      actualLastName: new FormControl('', [
        Validators.required,
        Validators.pattern("[a-zA-Z0-9 '-]*$"),
      ]),
    });
    this.passwordForm = new FormGroup({
      currentPassword: new FormControl('', Validators.required),
      newPassword: new FormControl('', Validators.required),
      confirmNewPassword: new FormControl('', Validators.required),
    });
    this.emailForm = new FormGroup({


      emailId: new FormControl('', [
        Validators.required,
        Validators.email,
        Validators.pattern(this.emailRegx),
      ]),
      confirmEmailId: new FormControl('', Validators.required),
    });
    this.alternateEmailForm = new FormGroup({


      alternateEmailId: new FormControl('', [
        Validators.required,
        Validators.email,
        Validators.pattern(this.emailRegx),
      ]),
      confirmAlternateEmailId: new FormControl('', Validators.required),
    });
    this.mobileForm = new FormGroup({
      mobileNumber: new FormControl('', [
        Validators.required,
        Validators.minLength(12),
        Validators.maxLength(12),
      ]),
    });
  }
  // ===============================Name field functions=======================
  setNameField() {
    this.nameForm.reset();
    let firstName = '';
    let lastName = '';
    if (this.loginUserInfo?.customerFirstName) {
      firstName = this.loginUserInfo.customerFirstName;
    }
    if (this.loginUserInfo?.customerLastName) {
      lastName = this.loginUserInfo.customerLastName;
    }

    this.nameForm.setValue({
      actualFirstName: firstName,
      actualLastName: lastName,
    });
    this.ref.detectChanges();
  }
  editNameField() {
    this.nameEditIsNotClicked = false;
  }
  updateNameField() {
    this.nameEditIsNotClicked = true;

    const params = {
      customerFirstName: this.nameForm.controls['actualFirstName'].value,
      customerLastName: this.nameForm.controls['actualLastName'].value,
      userName: this.customerId,
      profileUpdateType: 'NAME',
    };
    this.updateAllUserDataFields(params, 'name');
  }
  cancelNameUpdate() {
    this.nameEditIsNotClicked = true;
    this.setNameField();
  }
  // ===============================Role field functions=======================

  userRoleGetMethod() {
    this.pfService.getUserRoles();
    this.userRolesSubscriber = this.pfService.userRoles.subscribe((data) => {
      if (data) {
        this.roleOfUserArray = data;
        this.userRoleMapping();
      }
    });
  }

  userRoleMapping() {
    this.roleOfUserArray.forEach((res) => {
      if (
        this.loginUserInfo?.customerRole &&
        res.name === this.loginUserInfo?.customerRole
      ) {
        this.chosenRoleofUser = res.code;
        this.displayRoleofUser = res.name;
        this.ref.detectChanges();
      }
    });
  }

  editRoleField() {
    this.roleEditIsNotClicked = false;
  }
  updateRoleField() {
    this.roleEditIsNotClicked = true;
    this.roleOfUserArray.forEach((res) => {
      if (res.code === this.chosenRoleofUser) {
        this.displayRoleofUser = res.name;
        this.ref.detectChanges();
      }
    });

    const params = {
      customerRole: this.chosenRoleofUser,
      userName: this.customerId,
      profileUpdateType: 'ROLE',
    };
    this.updateAllUserDataFields(params, 'role');
  }
  cancelRoleUpdate() {
    this.roleEditIsNotClicked = true;
    this.userRoleMapping();
  }
  // ==================================================user disable========================

  editUserIdRadio() {
    this.userIdEditIsNotClicked = false;
  }
  cancelUserIdDisable() {
    this.userIdEditIsNotClicked = true;
    this.userIdDisableReadOnly = (this.loginUserInfo?.userDisabled).toString();
    this.userIdDisable = (this.loginUserInfo?.userDisabled).toString();
  }

  updateUserId() {
    const params = {
      userDisabled: this.userIdDisable,
      userName: this.customerId,
      profileUpdateType: 'USER_DISABLED',
    };
    this.userIdEditIsNotClicked = true;
    this.updateAllUserDataFields(params, 'userId');
  }
  // ===============================PassRec==========================================

  getPassWordRecQues() {
    this.pfService.getHintQuestions();
    this.passQueSubscriber = this.pfService.passQues.subscribe((data) => {
      if (data) {
        this.passRecQuesArray = data;
        this.passRecQueMapping();
        this.ref.detectChanges();
      }
    });
  }

  passRecQueMapping() {
    this.passRecQuesArray.forEach((res) => {
      if (
        this.loginUserInfo?.passwordQuestion &&
        this.loginUserInfo?.passwordQuestion !== null &&
        res.name === this.loginUserInfo?.passwordQuestion
      ) {
        this.chosenQueForPassRecovery = res.code;
      }
    });
  }

  setPassRecField() {
    if (
      this.loginUserInfo?.passwordQuestion &&
      this.loginUserInfo?.passwordAnswer
    ) {
      this.displayQueForPassRecovery = this.loginUserInfo?.passwordQuestion;
      this.ansForQuePassRecovery = this.loginUserInfo?.passwordAnswer;
    } else {
      this.displayQueForPassRecovery = '';
      this.ansForQuePassRecovery = null;
    }

    this.ref.detectChanges();
  }
  editPassRecField() {
    this.passRecEditIsNotClicked = false;
  }
  cancelPassRecUpdate() {
    this.passRecEditIsNotClicked = true;
    this.setPassRecField();
    this.passRecQueMapping();
  }

  // ===========================================Email Functions==============================
  setEmailForm() {
    this.emailForm.reset();
    this.emailForm.setValue({
      emailId: this.loginUserInfo?.email,
      confirmEmailId: '',
    });
    this.ref.detectChanges();
  }
  cancelEmailUpdate() {
    this.emailEditIsNotClicked = true;
    this.setEmailForm();
  }
  updateEmailField() {
    const params = {
      email: this.emailForm.controls['emailId'].value,
      confirmEmail: this.emailForm.controls['confirmEmailId'].value,
      userName: this.customerId,
      profileUpdateType: 'EMAIL_CHANGE_REQUEST',
    };
    this.emailEditIsNotClicked = true;
    this.updateAllUserDataFields(params, 'email');
  }
  editEmailField() {
    this.emailEditIsNotClicked = false;
  }

  // ===========================================Mobile Functions==============================
  setMobileForm() {
    this.mobileNumber = this.loginUserInfo?.mobileNumber || '';
    if (this.mobileNumber) {
      const countryCode = this.loginUserInfo?.mobileCountryCode || 'US';
      this.mobileNumberMasked = `(${countryCode}) ` + this.mobileNumber.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '***-***-$3');
    } else {
      this.mobileNumberMasked = '';
    }
    this.mobileForm.reset();
    this.mobileForm.patchValue({ mobileNumber: this.mobileNumber });
    this.ref.detectChanges();
  }
  editMobileField(state: string) {
    if (state === 'edit') {
      this.mobileEditIsNotClicked = false;
      this.mobileErrorMsg = null;
      this.ref.detectChanges(); // render input so appPhoneMask directive initialises
      setTimeout(() => {
        // re-set raw digits after directive is active so it formats to XXX-XXX-XXXX
        const raw = (this.mobileNumber || '').replace(/\D/g, '');
        this.mobileForm.controls['mobileNumber'].setValue(raw);
        this.ref.detectChanges();
      });
    } else {
      this.mobileEditIsNotClicked = true;
      this.mobileErrorMsg = null;
      this.ref.detectChanges(); // destroy directive before resetting form
      this.setMobileForm();
    }
  }
  validateMobileForm() {
    this.mobileErrorMsg = null;
  }
  updateMobileField() {
    this.mobileAddDisable = true;
    this.mobileErrorMsg = null;
    const params = {
      mobileNumber: this.mobileForm.controls['mobileNumber'].value
        ? this.mobileForm.controls['mobileNumber'].value.replace(/\D/g, '')
        : '',
      userName: this.customerId,
      profileUpdateType: 'MOBILE_CHANGE_REQUEST',
    };
    this.updateMobileData(params);
  }
  removeMobile() {
    this.mobileAddDisable = true;
    this.mobileErrorMsg = null;
    const params = {
      mobileNumber: '',
      userName: this.customerId,
      profileUpdateType: 'MOBILE_REMOVE',
    };
    this.updateMobileData(params);
  }
  updateMobileData(params: any) {
    this.userManagementService.updateCustomerDetails(this.customerId, params);
    this.updateDetailsSubscriber =
      this.userManagementService.updateCustDetails.pipe(skip(1), take(1)).subscribe(
        (res: any) => {
          this.mobileAddDisable = false;
          if (res === null) {
            this.mobileEditIsNotClicked = true;
            this.userManagementService.getCustomerDetails(this.customerId, 'mobile');
          } else if (res?.error?.errors?.length > 0) {
            this.globalMessage.remove(GlobalMessageType.MSG_TYPE_ERROR);
            this.mobileErrorMsg = res.error.errors[0]?.message
              || 'Some error occurred while updating mobile number.';
            this.ref.detectChanges();
          }
        }
      );
  }

  // ==================================UpdateDetals==========================
  updateAllUserDataFields(params, id) {
    this.userManagementService.updateCustomerDetails(this.customerId, params);
    this.updateDetailsSubscriber =
      this.userManagementService.updateCustDetails.subscribe(
        (res: any) => {
          if (res === null) {
            this.userManagementService.getCustomerDetails(this.customerId, id);
            this.updateDetailsSubscriber?.unsubscribe();
          } else {
            this.emailChangeRequested = id === 'email';
            if (res && res?.error?.errors?.length > 0) {
              //in service emitting error also as response.
              window.scrollTo(0, 0);
              let errMssg = res?.error?.errors[0]?.message
                ? res?.error?.errors[0]?.message
                : `Some error occured while updating the ${id} field.`;
              this.userManagementService.getCustomerDetails(
                this.customerId,
                id
              );
              this.updateDetailsSubscriber?.unsubscribe();
            }
          }
        },
        (err) => {
          if (err?.error?.errors?.length > 0) {
            window.scrollTo(0, 0);
            let errMssg = err?.error?.errors[0]?.message
              ? err?.error?.errors[0]?.message
              : `Some error occured while updating the ${id} field.`;
          }
          this.userManagementService.getCustomerDetails(this.customerId, id);
          this.updateDetailsSubscriber?.unsubscribe();
        }
      );
  }

  // ============================resetPasswordLink====================
  resetPasswordLink() {
    this.userManagementService.resetPasswordService(this.customerId, {});
    this.userManagementService.resetPasswordDetails.subscribe((data: any) => {
      if (data) {
        if (data?.resetPasswordEmailSent) {
          this.resetPasswordBoolean = data?.resetPasswordEmailSent;
        } else {
          this.resetPasswordBoolean = false;
        }
        this.ref.detectChanges();
      }
    });
  }
  backToView() {
    this.router.navigate(['/', 'userManagemt']);
  }
}
